<template>
  <div>
    <main class="main product-details-main">
      <PagesPath path-title1="محصولات بنی باکس" :pathTo1="$route.path" />
      <div class="container mt-4">
        <div class="weblog-list-main">
          <section
            class="skeleton-poroduct-list"
            v-if="loading || !sliders || !sliders.length"
          >
            <Skeleton v-for="i in 9" :key="i"></Skeleton>
          </section>
          <template v-else>
            <section class="w-100">
              <figure class="m-0 w-100 d-flex mb-5">
                <img
                  src="../../../assets//images/slider-beni-box.png"
                  alt=""
                  class="w-100"
                />
              </figure>
              <div class="content-products-search">
                <Product
                  class="w-100"
                  v-for="(product, index) in sliders"
                  :key="index"
                  :product="product"
                  :comparable="true"
                />
              </div>
            </section>
          </template>
        </div>
      </div>
      <!-- </div> -->
      <ScrollToTop></ScrollToTop>
      <!-- <FooterButtons></FooterButtons> -->
    </main>
    <!-- <Footer></Footer> -->
  </div>
</template>
<script>
import ScrollToTop from "@/parts/Front/components/ScrollToTop";
import Product from "@/parts/Front/components/product/Product";
import PagesPath from "@/parts/Front/components/PagesPath";
import Skeleton from "@/parts/Front/components/shared/skeleton";
export default {
  name: "BeniBox",
  components: {
    Product,
    PagesPath,
    ScrollToTop,
    Skeleton,
  },
  data() {
    return {
      readyProducts: null,
      loading: false,
    };
  },

  mounted() {
    this.setReadyProducts();
  },
  computed: {
    sliders() {
      return this.readyProducts;
    },
  },
  methods: {
    async setReadyProducts() {
      this.loading = true;
      this.readyProducts = null;
      try {
        let res = await this.$store.dispatch(
          "front/getIndexPageContent",
          "most-timed-discounts",
        );
        this.readyProducts = res;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.content-products-search {
  display: grid;
  gap: 1.5rem;
  grid-template-columns: repeat(5, 1fr);
}
.skeleton-poroduct-list {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 1rem;
}
.skeleton-poroduct-list .Skeleton {
  height: 400px;
}
.next-nav-mb,
.prev-nav-mb {
  display: none;
}
.main-product-list {
  /* margin-top: 200px; */
}
.product-list {
  /* position: relative; */
  /* top: -170px; */
}
.filter-btn-search {
  border-radius: 15px;
}
.line-product-list {
  width: 100%;
  height: 1px;
  background-color: #eaeaea;
}
.font-s-1-5 {
  font-size: 1.5rem !important;
}
@media screen and (max-width: 1500px) {
  /* .line-product-list{
    width: 35%;
   
  } */
  .content-products-search {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media screen and (max-width: 1200px) {
  /* .line-product-list{
    width: 25%;
   
  } */
  .content-products-search {
    grid-template-columns: repeat(3, 1fr);
  }
  .skeleton-poroduct-list {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media screen and (max-width: 992px) {
  .product-list {
    /* position:unset !important; */
  }
  .main-product-list {
    /* margin-top: 45px; */
  }
  /* .filter-buttons{
  position: relative;
  top: -25px;
} */
}
@media screen and (max-width: 768px) {
  /* .line-product-list{
    width: 45%;
   
  } */
  .content-products-search {
    gap: 1rem;
    grid-template-columns: repeat(2, 1fr);
  }
  .skeleton-poroduct-list {
    grid-template-columns: repeat(2, 1fr);
  }
  .title-top-products-list {
    justify-content: flex-start !important;
    gap: 16px;
  }
  .skeleton-poroduct-list .Skeleton {
    height: 340px;
  }
}
@media screen and (max-width: 500px) {
  /* .line-product-list{
    width: 30%;
   
  } */
  .skeleton-poroduct-list .Skeleton {
    height: 320px;
  }
}
@media screen and (max-width: 420px) {
  /* .line-product-list{
    width: 25%;
   
  } */
}
@media screen and (max-width: 370px) {
  /* .line-product-list{
    width: 25%;
   
  } */
}
.products-list-filter {
  /*background-color: var(--color-theme);*/
  background-color: #fff;
  border-radius: 15px;
}
.product-empty {
  grid-template-columns: 2fr !important;
}

.loading-container {
  position: absolute;
  top: 160px;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  background: var(--color-theme2);
  border-radius: 10px;
  padding: 10px 0 1px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  transition: 200ms all;
}

.main >>> .vue-treeselect__multi-value-item {
  color: white;
  background: var(--color-theme);
}
.main >>> .vue-treeselect__value-remove {
  color: white;
}

h2 {
  font-size: 1.75rem;
}

.mobile-category {
  color: var(--color-444);
  background-color: var(--color-ea);
  font-size: 15px;
  transition: 0.3s;
  display: flex !important;
  justify-content: center !important;
  margin-bottom: 0.5rem !important;
  padding: 0.7rem !important;
}
.mobile-category h2 {
  margin-bottom: 0;
  font-weight: bold;
  font-size: 1.3rem;
}
</style>
<style>
.page-item a {
  border-radius: 50% !important;
}
.pagination-next-nav a,
.pagination-prev-nav a {
  background-color: var(--color-brown) !important;
  display: grid !important;
  place-items: center;
}
.pagination-prev-nav a svg {
  transform: translateX(2px);
}
@media screen and (max-width: 468px) {
  .pagination-page-nav {
    display: none;
  }
  .next-nav-mb,
  .prev-nav-mb {
    display: block !important;
  }
  .pagination-prev-nav a,
  .pagination-next-nav a {
    width: fit-content !important;
    border-radius: 20px !important;
    width: 151px !important;
    height: 40px !important;
  }
  .pagination-prev-nav a {
    background-color: #484848 !important;
  }
  .pagination-next-nav a {
    background-color: var(--color-brown) !important;
  }
  .pagination-prev-nav a svg,
  .pagination-next-nav a svg {
    margin-bottom: 0 !important;
    background-color: #fff;
    border-radius: 50%;
    fill: #000 !important;
    width: 15px !important;
    height: 15px !important;
  }
  .pagination-prev-nav a svg g,
  .pagination-next-nav a svg g {
    fill: #000 !important;
  }
  .next-nav,
  .prev-nav {
    display: flex !important;
    width: fit-content !important;
    color: #fff !important;
    align-items: center;
    font-size: 13px !important;
    line-height: 2.5;
    justify-content: flex-start !important;
    gap: 22px;
    width: 100% !important;
  }
  .next-nav {
    padding-left: 10px;
    flex-direction: row-reverse;
  }
  .prev-nav {
    padding-right: 10px;
  }
}
</style>
